import {QueryKey} from '@tanstack/react-query';
import {useCallback} from 'react';

type KnownKeys = 'tasks' | 'tasks_hierarchy';
const keys = new Map<KnownKeys, QueryKey>();
export function useQueryKeys(key: KnownKeys) {
  const setKey = useCallback((value: QueryKey) => keys.set(key, value), [key]);
  return [keys.get(key), setKey] as const;
}
